export const fade = {
	initial: { opacity: 0 },
	animate: {
		opacity: 1,
		transition: { duration: 0.8, ease: [0.35, 0, 0, 1] },
	},
	exit: { opacity: 0 },
};

export const fadeUp = {
	initial: "hidden",
	animate: "animate",
	exit: "hidden",
	variants: {
		hidden: {
			y: 10,
			opacity: 0,
		},
		animate: {
			y: 0,
			opacity: 1,
		},
	},
};

export const fadeLeft = {
	initial: "hidden",
	animate: "animate",
	exit: "hidden",
	variants: {
		hidden: {
			x: "100%",
			opacity: 0,
		},
		animate: {
			x: 0,
			opacity: 1,
		},
	},
};

export const fadeHeight = {
	initial: "hidden",
	animate: "animate",
	exit: "hidden",
	variants: {
		hidden: {
			height: 0,
			opacity: 0,
		},
		animate: {
			height: "auto",
			opacity: 1,
		},
	},
};

export const slideUp = {
	initial: { opacity: 0, y: 30 },
	animate: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.8, ease: [0.35, 0, 0, 1] },
	},
	exit: { opacity: 0, y: -20 },
};

export const staggerContainer = {
	animate: {
		transition: {
			staggerChildren: 0.1,
		},
	},
};

export const transition = {
	duration: 0.45,
	ease: [0.35, 0, 0, 1], // Custom cubic-bezier
};
